import React, { useRef } from 'react'; import { DoubleSide } from 'three';
import { useGLTF } from '@react-three/drei'

export function AnD(props) {
    const group = useRef();
    const { nodes } = useGLTF('3ds/an/AnD.gltf');
    return (
        <group ref={group} {...props} dispose={null}>
            <mesh
                name="AnD"
                geometry={nodes.AnD.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/AnD.gltf')